import { Navigate, useNavigate } from 'react-router-dom'
import { AlertTriangle, ShieldAlert } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui'
import { LoadingScreen } from '@/components/LoadingScreen'
import { readPendingInvite } from '@/lib/invitePersistence'
import { resolveStudioAccessState } from '@/lib/studioAccessState'
import { useAuthStore, useStudioStore } from '@/store'

export function NoAccessPage() {
  const navigate = useNavigate()
  const { logout } = useAuthStore()
  const {
    studios,
    studiosSyncStatus,
    studiosSyncError,
    resetStudiosAccess,
  } = useStudioStore()
  const pendingInvite = readPendingInvite()
  const accessState = resolveStudioAccessState(studios.length, studiosSyncStatus)

  const handleLogout = () => {
    resetStudiosAccess()
    logout()
    navigate('/login', { replace: true })
  }

  if (accessState === 'granted') {
    return <Navigate to="/" replace />
  }

  if (accessState === 'pending') {
    return <LoadingScreen />
  }

  if (accessState === 'error') {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <Card className="w-full max-w-md p-6 text-center">
          <AlertTriangle className="mx-auto mb-4 h-12 w-12 text-red-500" />
          <h1 className="mb-2 text-xl font-semibold">Не удалось проверить доступ</h1>
          <p className="mb-6 text-sm text-muted-foreground">
            {studiosSyncError || 'Сервер временно не ответил. Ваш доступ не был изменён.'}
          </p>
          <div className="space-y-3">
            <Button className="w-full" onClick={() => window.location.reload()}>
              Повторить проверку
            </Button>
            <Button className="w-full" variant="outline" onClick={handleLogout}>
              Войти под другим аккаунтом
            </Button>
          </div>
        </Card>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-6 text-center">
        <ShieldAlert className="mx-auto mb-4 h-12 w-12 text-amber-500" />
        <h1 className="mb-2 text-xl font-semibold">Доступ ещё не оформлен</h1>
        <p className="mb-6 text-sm text-muted-foreground">
          Вход выполнен, но к аккаунту пока не привязаны студии или управляющая компания.
        </p>

        <div className="space-y-3">
          {pendingInvite && (
            <Button
              className="w-full"
              onClick={() => navigate(`/invite/${encodeURIComponent(pendingInvite.token)}`)}
            >
              Завершить приглашение
            </Button>
          )}
          <Button className="w-full" variant="outline" onClick={() => window.location.reload()}>
            Проверить доступ снова
          </Button>
          <Button className="w-full" variant="outline" onClick={handleLogout}>
            Войти под другим аккаунтом
          </Button>
        </div>
      </Card>
    </div>
  )
}
